import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/AuthGuard';

const PortalTicketsListPage = Loadable(lazy(() => import('../pages/portal/tickets/PortalTicketsListPage')));
const PortalNewTicketPage = Loadable(lazy(() => import('../pages/portal/tickets/PortalNewTicketPage')));
const PortalTicketDetailPage = Loadable(lazy(() => import('../pages/portal/tickets/PortalTicketDetailPage')));
const PortalResumoPage = Loadable(lazy(() => import('../pages/portal/resumo/PortalResumoPage')));
const PortalAtividadesPage = Loadable(lazy(() => import('../pages/portal/atividades/PortalAtividadesPage')));
const PortalEquipePage = Loadable(lazy(() => import('../pages/portal/equipe/PortalEquipePage')));
const PortalKbPage = Loadable(lazy(() => import('../pages/portal/kb/PortalKbPage')));
const PortalKbArtigoPage = Loadable(lazy(() => import('../pages/portal/kb/PortalKbArtigoPage')));

const PortalRoutes = {
  path: '/portal',
  element: (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  ),
  children: [
    // /portal (sem filho) cai direto na lista de chamados.
    { index: true, element: <Navigate to="/portal/tickets" replace /> },
    { path: 'tickets', element: <PortalTicketsListPage /> },
    { path: 'tickets/new', element: <PortalNewTicketPage /> },
    { path: 'tickets/:id', element: <PortalTicketDetailPage /> },
    { path: 'resumo', element: <PortalResumoPage /> },
    { path: 'atividades', element: <PortalAtividadesPage /> },
    { path: 'equipe', element: <PortalEquipePage /> },
    { path: 'kb', element: <PortalKbPage /> },
    { path: 'kb/:codigo', element: <PortalKbArtigoPage /> }
  ]
};

export default PortalRoutes;
